import { forwardRef, useEffect } from 'react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import "../../style/common/SuccessAndErrorModal.scss";
import { focusElemnt } from '../../utilityFunctions';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SuccessAndErrorModal = (props) => {
    const { onClose, open, dialogConfirmationMessage = '', width = '350px', height = 'auto', backgroundColor = '#fff', cancelRequired = false, buttonName = 'OK', zIndex = '1300', ...other } = props;
    useEffect(() => {
        focusElemnt('OKBtn')
    }, [])
    const handleOk = () => {
        if (cancelRequired) {
            onClose(true);
        } else {
            onClose(false);
        }
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper': {
                    width: width,
                    height: height,
                    borderRadius: '10px',
                    backgroundColor: backgroundColor,
                },
                zIndex: zIndex
            }}
            maxWidth="xs"
            TransitionComponent={Transition}
            open={open}
            {...other}
        >
            <DialogContent dividers>
                {dialogConfirmationMessage}
            </DialogContent>
            <DialogActions>
                {cancelRequired && (
                    <div className="dialog-cancel2" >
                        <Button autoFocus onClick={handleCancel}>
                            NO
                        </Button>
                    </div>
                )}
                <div className="dialog-confirm2">
                    <Button onClick={handleOk}>{buttonName}</Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default SuccessAndErrorModal